import React, {useEffect, useState} from "react";
import useStyles from "./styles";
import StyledTabs from "./components/StyledTabs";
import Heading from "./components/Heading";
import {useDispatch, useSelector} from "react-redux";
import OrderAssays from "./components/OrderAssays";
import OrderTerms from "./components/OrderTerms";
import OrderSummary from "./components/OrderSummary";
import {getCatalogWizard} from "@cabinet-packages/redux/actions/actionsCreators";

const PatientTabs = () => {
    const cl = useStyles();
    const dispatch = useDispatch();
    const [tabIndex, setTabIndex] = useState('0');
    const { listOfPatients } = useSelector(state => state.patients);
    const [promoCode, setPromoCode] = useState('');
    const [state, setState] = useState({checkedA: false, checkedB: false, checkedC: false});
    const {catalog, takeId}  = useSelector(state => state.assaysCatalog);

    // const handleGetPatients = useCallback(async () => {
    //     if (!listOfPatients && AccessKey.get()) {
    //         const uuid = localStorage.getItem('uuid');
    //         const phone = localStorage.getItem('activePatientPhone');
    //         const newListOfPatients = await checkPatient('CHECK', uuid, null, phone, AccessKey.get());
    //
    //         dispatch(setListOfPatients(false, false, newListOfPatients));
    //     }
    // }, [dispatch, listOfPatients]);
    //
    // useEffect(() => {
    //     handleGetPatients();
    // }, [handleGetPatients]);

    useEffect(() => {
        if (!catalog && takeId) dispatch(getCatalogWizard());
    }, [catalog, takeId]);

    return (<div className={cl.rootWrapper}>
        <div className={cl.root}>
            <Heading/>
            <StyledTabs selectedTab={[tabIndex, setTabIndex]}/>
            {/*{listOfPatients && <OrderDatePunkt selectedPatient={listOfPatients[tabIndex]}/>}*/}
            <OrderAssays/>
            <OrderTerms checkboxes={[state, setState]} promo={[promoCode, setPromoCode]}/>
            <OrderSummary/>
        </div>
    </div>);
};

export default PatientTabs;
